import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface ShowIconProps {
  mainColor?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

export default function ShowIcon({
  mainColor = RoutalPalette.primary40,
  height = `18px`,
  width = `10px`,
  style = {},
}: ShowIconProps) {
  return (
    <SvgIcon viewBox="0 0 18 10" fill="none" style={{ width: width, height: height, fill: `none`, ...style }}>
      <g>
        <path
          id="Vector"
          d="M1 7C1 7 3.90909 1 9 1C14.0909 1 17 7 17 7C17 7 14.0909 13 9 13C3.90909 13 1 7 1 7Z"
          stroke={mainColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M8.99999 9.25C10.205 9.25 11.1818 8.24264 11.1818 7C11.1818 5.75736 10.205 4.75 8.99999 4.75C7.79501 4.75 6.81818 5.75736 6.81818 7C6.81818 8.24264 7.79501 9.25 8.99999 9.25Z"
          stroke={mainColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
